import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppData } from '@shared/models/appdata.model';
import { OrderHistorySearchRequestV2, OrderHistoryResponseV2 } from '@core/models/order-history.model';
import { NotificationService } from '@core/services/notification.service';
import { FaqQuestionResponse } from '@app/sales/models/simcard.model';

export interface DealerContact {
  name: string;
  role: string;
  responsibilityAreas: string;
  phone: string;
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private http = inject(HttpClient);
  private appData = inject(AppData);
  private notificationService = inject(NotificationService);

  apiUrl = this.appData.apiUrl + '/api/v1';
  apiUrlV2 = this.appData.apiUrl + '/api/v2';

  orderHistoryV2Search(searchRequest: OrderHistorySearchRequestV2): Observable<OrderHistoryResponseV2> {
    const url = `${this.apiUrlV2}/order/order-history`;
    return this.http.post<OrderHistoryResponseV2>(url, searchRequest);
  }

  missingImeiSearch(searchRequest: OrderHistorySearchRequestV2): Observable<number> {
    const url = `${this.apiUrlV2}/order/missing-imei-count`;
    return this.http.post<number>(url, searchRequest);
  }

  getDealerContacts(): Observable<DealerContact[]> {
    const url = `${this.apiUrl}/support/dealer-contacts`;
    return this.http.get<DealerContact[]>(url);
  }

  getSupportDescription(): Observable<string> {
    const url = `${this.apiUrl}/support/support-information`;
    return this.http.get<{ htmlDescription: string }>(url).pipe(
      map(response => response.htmlDescription),
      catchError(error => {
        this.notificationService.error('Feil ved henting av support informasjon.');
        throw error;
      })
    );
  }

  getFaqQuestion(questionName: string): Observable<FaqQuestionResponse> {
    const url = `${this.apiUrl}/support/faq-question?questionName=${questionName}`;
    return this.http.get<FaqQuestionResponse>(url);
  }
}
